import { StyleSheet } from 'react-native'

import { WebDatePicker, colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Stack } from '@zet/design-system/layout'
import { B5 } from '@zet/design-system/typography'
import moment from 'moment'

import { B14, M14 } from '../typography'

const computeDate = (date?: string, durationInYears?: number) => {
  if (date) {
    if (date === 'CURRENT_DATE') {
      return moment().format('YYYY-MM-DD')
    }
    return moment(date).format('YYYY-MM-DD')
  } else if (durationInYears) {
    if (durationInYears < 0) {
      return moment()
        .subtract(Math.abs(durationInYears), 'years')
        .format('YYYY-MM-DD')
    } else {
      return moment().add(durationInYears, 'years').format('YYYY-MM-DD')
    }
  }
}

interface Props {
  label: string
  onChange: (date: string) => void
  onBlur: () => void
  value: string
  errors: any
  isRequired?: boolean
  config?: {
    minDateDuration?: number // In years
    maxDateDuration?: number // In years
    minDate?: string
    maxDate?: string
    required?: boolean
  }
  errorMessage: string
  example: string
}

export const DateSelector = ({
  label,
  onChange,
  onBlur,
  value,
  errors,
  config,
  errorMessage,
  example,
}: Props) => {
  const minDate = computeDate(config?.minDate, config?.minDateDuration)
  const maxDate = computeDate(config?.maxDate, config?.maxDateDuration)

  return (
    <Stack className="mt-1">
      <M14 className="mb-2">{label}</M14>
      <Stack className={`justify-center rounded-md bg-[#F6F7F8]`}>
        <Icon
          type="CalenderOutlined"
          color={zetColors.grays[80]}
          className="absolute ml-2"
          size={22}
          viewBox={'0 0 20 20'}
        ></Icon>
        <WebDatePicker
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.value)
          }}
          onBlur={onBlur}
          value={value ? value : ''}
          minDate={minDate ?? null}
          maxDate={maxDate ?? null}
          style={styles.datePicker}
          isWebView={true}
          placeholder="Enter Date of Birth"
        />
      </Stack>
      {errors?.name?.message || errorMessage ? (
        <Stack className="mt-2">
          <B5 className="text-error-100">
            {errors?.name?.message || errorMessage}
          </B5>
        </Stack>
      ) : null}
      {!value && example ? (
        <B14 className="text-grays-80 mt-2">{example}</B14>
      ) : null}
    </Stack>
  )
}

const styles = StyleSheet.create({
  datePicker: {
    fontSize: 14,
    fontFamily: 'JioType-Medium',
    paddingVertical: 14,
    width: '100%',
    paddingLeft: 35,
    zIndex: 1,
    borderWidth: 0,
  },
})
